import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface ClothingMarkerAssignmentListItem {
  id: string;
  name: string;
  selected: boolean;
}

@Component({
  selector: 'app-clothing-marker-assignment-panel',
  templateUrl: './clothing-marker-assignment-panel.component.html',
  styleUrls: ['./clothing-marker-assignment-panel.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClothingMarkerAssignmentPanelComponent {
  @Input() titleKey = '';
  @Input() noteKey = '';
  @Input() emptyItemsKey = '';
  @Input() emptyMarkersKey = '';
  @Input() currentMarkerCode = '';
  @Input() items: ClothingMarkerAssignmentListItem[] = [];
  @Input() isSaving = false;
  @Input() isScrollable = false;
  @Output() previousMarker = new EventEmitter<void>();
  @Output() nextMarker = new EventEmitter<void>();
  @Output() selectItem = new EventEmitter<string>();

  get hasMarker(): boolean {
    return this.currentMarkerCode.length > 0;
  }

  get hasItems(): boolean {
    return this.items.length > 0;
  }

  movePrevious() {
    this.previousMarker.emit();
  }

  moveNext() {
    this.nextMarker.emit();
  }

  select(itemId: string, button: HTMLButtonElement) {
    this.blurButton(button);
    this.selectItem.emit(itemId);
  }

  trackByItem(index: number, item: ClothingMarkerAssignmentListItem): string {
    return item.id;
  }

  private blurButton(button: HTMLButtonElement) {
    if (!button) {
      return;
    }
    button.blur();
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/clothing/clothing-marker-assignment-panel.component.ts